/* eslint-disable react-hooks/rules-of-hooks */
import {
	setModalAddFund,
	setModalBuyNow,
	setModalSuccess,
} from "@/app/modal/actions";
import useCheckNotification from "@/hooks/useCheckNotification";
import useGetBalanceOpv from "@/hooks/useGetBalanceOpv";
import useGetOpvPrice from "@/hooks/useGetOpvPrice";
import useGetPreListing from "@/hooks/useGetPreListing";
import { Modal } from "antd";
import { minBy } from "lodash";
import { memo, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import Web3 from "web3";
import {
	useCancelOrder,
	useFillOrder,
	useGenMultiSignature,
	useGenSignature,
} from "../../hooks/useBuyTransaction";
import useERC20Contract from "../../hooks/useERC20Contract";
import { useTokenAllowance } from "../../hooks/useReadContractWithABI";
import useGetGasPrice from "../../hooks/useGetGasPrice";
import useMarketplaceContract from "../../hooks/useMarketplaceContract";
import { StatusCodeResponse } from "../../network/constants";
import NFTDetailServices from "../../network/nftDetail/services";
import { MARKETPLACE_ADDRESS, OPV } from "../../utils/constant";
import {
	formatterUnit,
	getTransactionReceiptMined,
	toLocaleString,
} from "../../utils/util";
import { hideLoading, showLoading } from "../common/loading/store/slice";
import { clearToken, selectWalletAddress } from "../connectWallet/store/slice";
import ArrowDropdownIcon from "../icons/ArrowDropdownIcon";
import { clearMyProfile } from "../myProfile/store/slice";
import "./styles.scss";
import { BigNumber, ethers } from "ethers";
import { formatUnits } from "@ethersproject/units";

import defaultAvatar from "@/assets/images/default-avatar.png";
export enum EnumERCStandard {
	ERC_721 = "ERC_721",
	ERC_1155 = "ERC_1155",
}

const web3 = new Web3(
	Web3.givenProvider ||
		"wss://speedy-nodes-nyc.moralis.io/d682253c26212ac170504417/bsc/testnet/ws"
);

const ModalBuyNow = () => {
	// state & hook
	const history = useHistory();
	const dispatch = useDispatch();
	const account = useSelector(selectWalletAddress);
	const { addToast } = useToasts();
	const { modalBuyNow } = useSelector((state: any) => state.modal);
	const [opvPrice] = useGetOpvPrice();
	const [opvBalance] = useGetBalanceOpv();
	const { getUnreadNotification } = useCheckNotification();
	const getPreListing = useGetPreListing();

	const [openPriceDetailt, setOpenPriceDetailt] = useState<boolean>(true);
	const [transaction, setTransaction] = useState<any>(null);
	const [transactions, setTransactions] = useState<any>([]);

	const [estimateGas, setEstimateGas] = useState<number>(0);
	const [price, setPrice] = useState<BigNumber>(BigNumber.from("0"));
	const [uri, setUri] = useState<string>("");
	const [isApproved, setIsApproved] = useState<boolean>(false);
	const [serviceFee, setServiceFee] = useState<any>({
		serviceFee: 0,
		creatorEarning: 0,
	});
	const [royaltiesFee, setRoyaltiesFee] = useState<BigNumber>(BigNumber.from("0"));
	const [decimals, setDecimals] = useState<number>(18);

	// smart contract
	const marketplaceContract = useMarketplaceContract(MARKETPLACE_ADDRESS);
	const opvContract = useERC20Contract(OPV);
	const estimateGas2 = () => {
		const base = 0.000381854;
		const max = base + base * 0.2; // Tăng 20%
		const randomValue = Math.random() * (max - base) + base; // Sinh số ngẫu nhiên trong khoảng [base, max]
		return parseFloat(randomValue.toFixed(9)); // Làm tròn tới 9 chữ số thập phân
	};
	useMemo(() => {
		const randomGas: any = estimateGas2();
		setEstimateGas(randomGas);
		if (modalBuyNow?.transaction) {
			// console.log(`go to case modalBuyNow?.transaction`);
			setTransaction(modalBuyNow?.transaction);
		} else if (modalBuyNow?.data?.currentListing?.length > 0) {
			// console.log(`go to case modalBuyNow?.data?.currentListing?.length > 0`);
			// console.log(modalBuyNow);
			// const selectedTrans = minBy(
			// 	modalBuyNow?.data?.currentListing.filter(
			// 		(x: any) => x.quantity >= modalBuyNow?.quantity
			// 	),
			// 	"quantity"
			// );
			const selectedTrans = minBy(
				modalBuyNow?.data?.currentListing,
				"listingPrice"
			);
			// console.log(`selectedTrans`);
			// console.log(selectedTrans);
			setTransaction(selectedTrans);
		} else {
			// console.log(`go to no case`);
		}

		if (modalBuyNow?.transactions) {
			setTransactions(modalBuyNow?.transactions);
		}
	}, [
		modalBuyNow?.transaction,
		modalBuyNow?.data?.currentListing,
		modalBuyNow?.quantity,
		modalBuyNow?.transactions,
	]);

	useMemo(() => {
		const data = modalBuyNow?.data.length
			? modalBuyNow?.data[0]
			: modalBuyNow?.data;

		if (account && data?.currentPrice) {
			const bgPrice = ethers.utils.parseUnits(
				data.currentPrice.toString(),
				decimals
			);
			setPrice(bgPrice);
		}
	}, [account, modalBuyNow?.data, opvContract]);

	useMemo(async () => {
		const data = modalBuyNow?.data.length
			? modalBuyNow?.data[0]
			: modalBuyNow?.data;
		if (data?.id && !data?.freeze) {
			const uriRes = await NFTDetailServices.getNFTFreezeUri(data?.id);
			if (uriRes?.status === StatusCodeResponse.SUCCESS) {
				const stringArray = uriRes?.data?.data?.full_path?.split("/");
				setUri(stringArray[stringArray.length - 1]);
			} else {
				console.log(uriRes);
				addToast(
					uriRes?.data?.message ??
						`Buy nft is failed(124): ${
							uriRes?.data?.message || uriRes?.message || ""
						}!.`,
					{
						appearance: "error",
					}
				);

				dispatch(
					setModalBuyNow({
						toggle: false,
						data: {},
					})
				);
			}
		}
	}, [addToast, dispatch, modalBuyNow?.data]);

	const handleGenTransSignature = useGenSignature();
	const handleGenMultiSignature = useGenMultiSignature();
	const handleCancelOrder = useCancelOrder();
	const handFillOrder = useFillOrder();
	const getGasPrice = useGetGasPrice();

	const buyNft = async () => {
		let fillOrderTrans: any = null;
		const transactionIds = transactions.map((tx: any) => tx.id); // Extract IDs from transactions
		if (transactions.length) {
			// If there are multiple transactions
			handleGenMultiSignature(
				transactionIds,
				{ amount: +modalBuyNow?.quantity, onlyGenSig: false },
				async (res: any) => {
					if (opvContract && marketplaceContract) {
						if (res) {
							const { sigs } = res;
							fillOrderTrans = res.transactions;
							if (!fillOrderTrans) {
								addToast("Cannot create fill order, please try it again.", {
									appearance: "error",
								});
								return;
							}

							const data = modalBuyNow?.data.length
								? modalBuyNow?.data[0]
								: modalBuyNow?.data;

							const { owners: currentOwners, prices, quantities, totalAmount: approve_amount } = transactions.reduce(
								(acc: any, tx: any) => {
									const unitPriceBN = ethers.utils.parseUnits(tx.listingPrice.toString(), decimals);
									const quantity = tx.quantity || 0;

									acc.owners.push(tx.ownerAddress);
									acc.prices.push(unitPriceBN.toString());
									acc.quantities.push(quantity);

									acc.totalAmount = acc.totalAmount.add(unitPriceBN.mul(quantity));

									return acc;
								},
								{ owners: [], prices: [], quantities: [], totalAmount: ethers.BigNumber.from(0).add(royaltiesFee) }
							);

							const transactionIds = fillOrderTrans.map((tx: any) => tx?.id);
							const nftIds = fillOrderTrans?.length
								? fillOrderTrans.map((tx: any) => tx?.nft?.nftId)
								: [modalBuyNow.data.nftId];
							const contractAddress =
								data?.catalog?.contractAddress || data.contractAddress;
							const uris = transactions.map(() => (uri ? uri : ""));

							const params = data?.freeze
								? [
										currentOwners,
										prices,
										quantities,
										transactionIds,
										sigs,
										nftIds,
										OPV,
										contractAddress,
								  ]
								: [
										currentOwners,
										prices,
										quantities,
										transactionIds,
										sigs,
										nftIds,
										OPV,
										contractAddress,
										uris,
								  ];

							if (!isApproved) {
								try {

									opvContract
										.approve(MARKETPLACE_ADDRESS, approve_amount)
										.then(async (res: any) => {
											const receipt: any = await getTransactionReceiptMined(
												web3,
												res?.hash,
												500
											);

											if (receipt?.status) {
												setIsApproved(true);
												dispatch(hideLoading());
											}
										})
										.catch((e: any) => {
											dispatch(
												setModalBuyNow({
													toggle: false,
													data: {},
												})
											);
											dispatch(hideLoading());
											console.log(e);
											setIsApproved(false);
											addToast(
												`Buy nft is failed(216): ${
													e?.data?.message || e?.message || ""
												}!`,
												{
													appearance: "error",
												}
											);
										});
								} catch (error) {
									dispatch(
										setModalBuyNow({
											toggle: false,
											data: {},
										})
									);
									dispatch(hideLoading());
									console.log(error);
									addToast(
										`Buy nft is failed(232): ${
											error?.data?.message || error?.message || ""
										}!`,
										{
											appearance: "error",
										}
									);
								}
							} else {
								try {
									console.log(params);
									marketplaceContract[
										data?.freeze
											? "fillOrderWithSignOnChain"
											: "fillOrderWithSignature"
									](...params)
										.then(async (res: any) => {
											console.log(`run 263`);
											console.log(res);
											// save transaction hash

											for (const fillOrderTran of fillOrderTrans) {
												await handFillOrder(fillOrderTran?.id, {
													transactionHash: res?.hash,
												});
											}

											const receipt: any = await getTransactionReceiptMined(
												web3,
												res?.hash,
												500
											);

											if (receipt) {
												dispatch(hideLoading());
												addToast("Buy NFT is successfully!.", {
													appearance: "success",
												});
												getUnreadNotification();
												dispatch(
													setModalSuccess({
														toggle: true,
														data: {
															title: "Your purchase is success",
															nft: data,
															transaction: res?.hash,
														},
													})
												);
												dispatch(
													setModalBuyNow({
														toggle: false,
														data: {},
													})
												);
												setTransactions([]);
												setIsApproved(false);
											}
										})
										.catch(async (e: any) => {
											console.log(`cancel because : 299`);
											console.log(e);

											for (const fillOrderTran of fillOrderTrans) {
												handleCancelOrder(fillOrderTran?.id, () => {
													console.log(e.message);
													setIsApproved(false);
													addToast(
														`Buy nft is failed(342): ${e?.message || ""}!`,
														{
															appearance: "error",
														}
													);
												});
											}
											dispatch(
												setModalBuyNow({
													toggle: false,
													data: {},
												})
											);
											dispatch(hideLoading());
										});
								} catch (error) {
									console.log(`cancel because : 316`);
									console.log(error);

									for (const fillOrderTran of fillOrderTrans) {
										handleCancelOrder(fillOrderTran?.id, () => {
											console.log(error);
											setIsApproved(false);
											addToast(
												`Buy nft is failed(303): ${
													error?.data?.message || error?.message || ""
												} !`,
												{
													appearance: "error",
												}
											);
										});
									}
									dispatch(
										setModalBuyNow({
											toggle: false,
											data: {},
										})
									);
									dispatch(hideLoading());
								}
							}
						}
					} else {
						dispatch(hideLoading());
						dispatch(clearToken());
						dispatch(clearMyProfile());
						localStorage.setItem("accessToken", "");
						localStorage.setItem("refreshToken", "");
						localStorage.setItem("_accountId", "");
					}
				},
				(err: any) => {
					dispatch(hideLoading());
					console.log(err);
					addToast(
						`Cannot generate buy nft signature: ${err?.data?.message || ""}.`,
						{
							appearance: "error",
						}
					);
				}
			);
		} else {
			handleGenTransSignature(
				transaction?.id,
				{ amount: +modalBuyNow?.quantity, onlyGenSig: false },
				async (res: any) => {
					if (opvContract && marketplaceContract) {
						if (res) {
							const { sig } = res;
							fillOrderTrans = res.transaction;

							if (!fillOrderTrans) {
								addToast("Cannot create fill order, please try it again.", {
									appearance: "error",
								});
								return;
							}
							// rang of uint256
							// let approve_amount = `${modalBuyNow?.quantity * parseInt(price)}`; //(2^256 - 1 )
							const unitPrice = modalBuyNow?.data?.currentPrice || 0;
							const quantity = modalBuyNow?.quantity || 1;
							const totalPrice = unitPrice * quantity;
							const totalPriceWei = ethers.utils.parseUnits(totalPrice.toString(), decimals);
							const approve_amount = totalPriceWei.add(royaltiesFee);

							let currentOwner =
								modalBuyNow?.data?.currentListing[0].ownerAddress;
							const params = modalBuyNow?.data?.freeze
								? [
										[currentOwner],
										[price.toString()],
										[modalBuyNow?.quantity],
										[fillOrderTrans?.id],
										[sig],
										[modalBuyNow?.data?.nftId],
										OPV,
										modalBuyNow?.data?.catalog?.contractAddress,
								  ]
								: [
										[currentOwner],
										[price.toString()],
										[modalBuyNow?.quantity],
										[fillOrderTrans?.id],
										[sig],
										[modalBuyNow?.data?.nftId],
										OPV,
										modalBuyNow?.data?.catalog?.contractAddress,
										uri ? [uri] : [],
								  ];

							if (!isApproved) {
								try {
									opvContract
										.approve(MARKETPLACE_ADDRESS, approve_amount)
										.then(async (res: any) => {
											const receipt: any = await getTransactionReceiptMined(
												web3,
												res?.hash,
												500
											);

											if (receipt?.status) {
												setIsApproved(true);
												dispatch(hideLoading());
											}
										})
										.catch((e: any) => {
											dispatch(
												setModalBuyNow({
													toggle: false,
													data: {},
												})
											);
											dispatch(hideLoading());
											console.log(e);
											setIsApproved(false);
											addToast(
												`Buy nft is failed(216): ${
													e?.data?.message || e?.message || ""
												}!`,
												{
													appearance: "error",
												}
											);
										});
								} catch (error) {
									dispatch(
										setModalBuyNow({
											toggle: false,
											data: {},
										})
									);
									dispatch(hideLoading());
									console.log(error);
									setIsApproved(false);
									addToast(
										`Buy nft is failed(232): ${
											error?.data?.message || error?.message || ""
										}!`,
										{
											appearance: "error",
										}
									);
								}
							} else {
								try {
									marketplaceContract[
										modalBuyNow?.data?.freeze
											? "fillOrderWithSignOnChain"
											: "fillOrderWithSignature"
									](...params)
										.then(async (res: any) => {
											console.log(`run 526`);
											console.log(res);
											// save transaction hash
											await handFillOrder(fillOrderTrans?.id, {
												transactionHash: res?.hash,
											});

											const receipt: any = await getTransactionReceiptMined(
												web3,
												res?.hash,
												500
											);

											if (receipt) {
												dispatch(hideLoading());
												addToast("Buy NFT is successfully!.", {
													appearance: "success",
												});
												getUnreadNotification();
												dispatch(
													setModalSuccess({
														toggle: true,
														data: {
															title: "Your purchase is success",
															nft: modalBuyNow?.data,
															transaction: res?.hash,
														},
													})
												);
												dispatch(
													setModalBuyNow({
														toggle: false,
														data: {},
													})
												);
											}
										})
										.catch(async (e: any) => {
											console.log(`cancel because : 564`);
											console.log(e);
											handleCancelOrder(fillOrderTrans?.id, () => {
												console.log(e.message);
												setIsApproved(false);
												addToast(
													`Buy nft is failed(557): ${e?.message || ""}!`,
													{
														appearance: "error",
													}
												);
											});
											dispatch(
												setModalBuyNow({
													toggle: false,
													data: {},
												})
											);
											dispatch(hideLoading());
											setTransaction(null);
											setIsApproved(false);
										});
								} catch (error) {
									console.log(`cancel because : 316`);
									console.log(error);
									handleCancelOrder(fillOrderTrans?.id, () => {
										console.log(error);
										setIsApproved(false);
										addToast(
											`Buy nft is failed(303): ${
												error?.data?.message || error?.message || ""
											} !`,
											{
												appearance: "error",
											}
										);
									});
									dispatch(
										setModalBuyNow({
											toggle: false,
											data: {},
										})
									);
									dispatch(hideLoading());
								}
							}
						}
					} else {
						dispatch(hideLoading());
						dispatch(clearToken());
						dispatch(clearMyProfile());
						localStorage.setItem("accessToken", "");
						localStorage.setItem("refreshToken", "");
						localStorage.setItem("_accountId", "");
					}
				},
				(err: any) => {
					dispatch(hideLoading());
					console.log(err);
					addToast(
						`Cannot generate buy nft signature: ${err?.data?.message || ""}.`,
						{
							appearance: "error",
						}
					);
				}
			);
		}
	};

	const handlePayment = async () => {
		dispatch(showLoading());

		try {
			await buyNft();
		} catch (e) {
			dispatch(hideLoading());
			console.log(e);
			setIsApproved(false);
			addToast(
				`Buy nft is failed(349): ${e?.data?.message || e?.message || ""}!.`,
				{
					appearance: "error",
				}
			);
		}
	};

	const handleCancel = () => {
		setIsApproved(false);
		setPrice(BigNumber.from("0"));
		setEstimateGas(0);
		setUri("");
		dispatch(
			setModalBuyNow({
				toggle: false,
				data: {},
			})
		);
	};

	const handleAddFund = () => {
		dispatch(
			setModalBuyNow({
				toggle: false,
				data: {},
			})
		);
		dispatch(
			setModalAddFund({
				toggle: true,
			})
		);
	};

	const requiredAmount = useMemo(() => {
		let totalRoyaltiesFee = BigNumber.from(0);
		if (modalBuyNow?.quantity > 1 && Array.isArray(modalBuyNow?.data)) {
			for (const item of modalBuyNow?.data) {
				if (item?.id) {
					const basePrice = ethers.utils.parseUnits(item?.currentPrice, decimals).mul(modalBuyNow?.quantity);
					const royaltiesBps = Number(item.catalog?.royalties || 0);
					totalRoyaltiesFee = totalRoyaltiesFee.add(basePrice.mul(royaltiesBps).div(10000));
				}
			}
		} else {
			if (modalBuyNow?.data?.id) {
				const basePrice = ethers.utils.parseUnits(String(modalBuyNow?.data?.currentPrice * modalBuyNow?.quantity), decimals);
				const royaltiesBps = Number(modalBuyNow?.data?.catalog?.royalties ?? 0);
				totalRoyaltiesFee = basePrice.mul(royaltiesBps).div(10000);
			}
		}
		setRoyaltiesFee(totalRoyaltiesFee);
		const quantity = modalBuyNow?.quantity || 1;
		return price
			.mul(quantity)
			.add(totalRoyaltiesFee)
	}, [price, modalBuyNow?.quantity, modalBuyNow?.data]);

	// Use custom hook to check token allowance
	const { data: allowance, refetch: refetchAllowance } = useTokenAllowance(
		OPV,
		account || "",
		MARKETPLACE_ADDRESS
	);

	// Update approval status when allowance or required amount changes
	useEffect(() => {
		if (account && requiredAmount.gt(0) && allowance) {
			// Match original logic: setIsApproved(balanceAllowance.gte(requiredAmount))
			setIsApproved(allowance.gte(requiredAmount));
		}
	}, [account, opvContract, price, modalBuyNow?.quantity]);

	// Old useEffect for allowance checking has been replaced with useTokenAllowance hook
	// useEffect(() => {
	// 	if (opvContract && account && requiredAmount.gt(0)) {
	// 		opvContract
	// 			.allowance(account, MARKETPLACE_ADDRESS)
	// 			.then(async (balanceAllowance: any) => {
	// 				setIsApproved(balanceAllowance.gte(requiredAmount));
	// 			})
	// 			.catch(error => {
	// 				console.error("Error when checking allowance:", {
	// 					account,
	// 					MARKETPLACE_ADDRESS,
	// 					price: requiredAmount.toString(),
	// 					error,
	// 				});
	// 			});
	// 	}
	// }, [account, opvContract, price, modalBuyNow?.quantity]);


	useEffect(() => {
		const data = modalBuyNow?.data.length
			? modalBuyNow?.data[0]
			: modalBuyNow?.data;

		if (
			transaction?.id &&
			uri &&
			price &&
			marketplaceContract &&
			isApproved &&
			modalBuyNow?.quantity
		) {
			handleGenTransSignature(
				transaction?.id,
				{ amount: +modalBuyNow?.quantity, onlyGenSig: true },
				async (res: any) => {
					const { sig } = res;
					const transactionEstimateGas = res.transaction;
					let currentOwner = data?.currentListing[0].ownerAddress;
					const params = data?.freeze
						? [
								[currentOwner],
								[price.toString()],
								[modalBuyNow?.quantity],
								[transactionEstimateGas?.id],
								[sig],
								[data?.nftId],
								OPV,
								data?.catalog?.contractAddress,
						  ]
						: [
								[currentOwner],
								[price.toString()],
								[modalBuyNow?.quantity],
								[transactionEstimateGas?.id],
								[sig],
								[data?.nftId],
								OPV,
								data?.catalog?.contractAddress,
								uri ? [uri] : [],
						  ];

					const gasFee = await marketplaceContract?.estimateGas[
						data?.freeze ? "fillOrderWithSignOnChain" : "fillOrderWithSignature"
					](...params);

					const gasPrice = await getGasPrice();
					setEstimateGas(
						gasPrice * (gasFee ? gasFee?.toNumber() / 10 ** 9 : 0)
					);
				}
			);
		}
	}, [
		price,
		transaction?.id,
		uri,
		isApproved,
		marketplaceContract,
		modalBuyNow?.quantity,
		modalBuyNow?.data,
		handleGenTransSignature,
		getGasPrice,
	]);

	useMemo(async () => {
		if (modalBuyNow?.quantity > 1 && Array.isArray(modalBuyNow?.data)) {
			let totalServiceFee = { serviceFee: 0, creatorEarning: 0 };
			for (const item of modalBuyNow?.data) {
				if (item?.id) {
					const paramGetPreListing = {
						nftId: item?.id,
						listingType: item?.listing,
						listingPrice: +item?.currentPrice,
						quantity: 1,
						duration: 86400,
					};

					const rsFee = await getPreListing(paramGetPreListing);
					totalServiceFee.serviceFee += rsFee.serviceFee;
					totalServiceFee.creatorEarning += rsFee.creatorEarning;
				}
			}
			setServiceFee(totalServiceFee);
		} else {
			if (modalBuyNow?.data?.id) {
				const paramGetPreListing = {
					nftId: modalBuyNow?.data?.id,
					listingType: modalBuyNow?.data?.listing,
					listingPrice: +modalBuyNow?.data?.currentPrice,
					quantity: +modalBuyNow?.quantity,
					duration: 86400,
				};

				const rsFee = await getPreListing(paramGetPreListing);
				setServiceFee(rsFee);
			}
		}
	}, [getPreListing, modalBuyNow?.data, modalBuyNow?.quantity]);

	useEffect(() => {
		const fetchDecimals = async () => {
			if (!opvContract) return;
			try {
				const d = await opvContract.decimals();
				setDecimals(d);
			} catch (error) {
				console.error("Error get decimals:", error);
			}
		};
		fetchDecimals();
	}, [opvContract]);

	const data = modalBuyNow?.data.length
		? modalBuyNow?.data[0]
		: modalBuyNow?.data;

	return (
		<Modal
			title="Checkout"
			visible={modalBuyNow?.toggle}
			onOk={handlePayment}
			onCancel={handleCancel}
			className="modal-buy-now-nft"
			footer={false}
			style={{ bottom: 0 }}
		>
			<div className="approve-nft-info">
				<div className="approve-nft-info-image">
					{data?.animationUrl && data?.animationUrl !== "Unknown" ? (
						<iframe
							src={`${
								data?.animationUrl || data?.mediaUrl
							}?autoplay=1&loop=1&autopause=0&controls=0&muted=1`}
							className="absolute top-0 left-0 w-full h-full object-cover duration-2000 pointer-events-none"
							allowFullScreen
							title={data?.name}
						/>
					) : (
						<img
							src={
								data?.mediaUrl !== "Unknown"
									? data?.mediaUrl
									: defaultAvatar
							}
							alt={data?.name}
						/>
					)}

					<div className="approve-nft-info-image-quantity">
						<p>
							<span>{modalBuyNow?.quantity}</span>
						</p>
					</div>
				</div>
				<div className="approve-nft-info-name">
					<p>{data?.name}</p>
					{modalBuyNow?.quantity == 1 && (
						<p>
							{data?.catalog?.displayName
								? data?.catalog?.displayName
								: data?.catalog?.name}
						</p>
					)}
				</div>
				<div className="approve-nft-info-price">
					<p>{data?.currentPrice} MBC</p>
					<p>
						$
						{data?.currentPrice
							? formatterUnit(data?.currentPrice * +opvPrice, 3)
							: 0}
					</p>
				</div>
			</div>
			<div className="approve-nft-price">
				<button
					type="button"
					onClick={() => setOpenPriceDetailt((prev) => !prev)}
				>
					<p>
						Total <b>{data?.currentPrice * modalBuyNow?.quantity} MBC</b>{" "}+{" "}
						<b>{formatterUnit(parseFloat(formatUnits(royaltiesFee, decimals)), 3)} MBC</b>{" "}+{" "}
						<b>{estimateGas ?? 0} BNB</b>
					</p>

					<ArrowDropdownIcon
						style={{
							transform: openPriceDetailt ? "rotate(0)" : "rotate(180deg)",
							transition: "0.2s",
						}}
					/>
				</button>

				{openPriceDetailt && (
					<>
						<div className="approve-nft-price-wrap-item">
							<div className="approve-nft-price-item">
								<div>Listing price</div>
								<div>
									{data?.currentPrice * modalBuyNow?.quantity} MBC ($
									{data?.currentPrice
										? formatterUnit(
												data?.currentPrice * +opvPrice * modalBuyNow?.quantity,
												3
										  )
										: 0}
									)
								</div>
							</div>
							<div className="approve-nft-price-item">
								<div>Royalty fee</div>
								<div>
									<b>
										{formatterUnit(parseFloat(formatUnits(royaltiesFee, decimals)), 3)} MBC ($
										{royaltiesFee
											? formatterUnit(parseFloat(formatUnits(royaltiesFee, decimals)) * +opvPrice, 3)
											: 0}
										)
									</b>
								</div>
							</div>
							<div className="approve-nft-price-item">
								<div>Service fee</div>
								<div>
									<b>
										{formatterUnit(serviceFee?.serviceFee, 3)} MBC ($
										{serviceFee?.serviceFee
											? formatterUnit(serviceFee?.serviceFee * +opvPrice, 3)
											: 0}
										)
									</b>
								</div>
							</div>
						</div>
					</>
				)}
			</div>

			<div className="approve-nft-action">
				{+opvBalance >= +data?.currentPrice ? (
					<>
						<button type="button" onClick={handlePayment}>
							{isApproved ? "Proceed to payment" : "Approve"}
						</button>
					</>
				) : (
					<>
						<button type="button" onClick={handleAddFund}>
							Add fund
						</button>
						<p className="m-0 text-[#999] md:text-base text-xs text-center lg:mt-[24px] mt-[16px]">
							Insufficient MBC Balance
						</p>
					</>
				)}
			</div>
		</Modal>
	);
};

export default memo(ModalBuyNow);
